import { FlowChartNode } from './flow-chart-node';

export class FlowChartLink {
  source: FlowChartNode;
  target: any; // any because of mapping in the components in order to create link lines (actual type FlowChartNode)
  value: string;
  isTwoWay?: boolean;
}
